window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function (timeOutFn) {
  return setTimeout(timeOutFn, 1000 / 60);
};

window['cp_sp_hp_05_v2'] = function () {
  if (typeof $ == 'function' && $('.slideshow_tmd.mobile').length > 0 && !document.querySelector('.cp_sp_hp_05_v2')) {
    $('body').addClass('cp_sp_hp_05_v2');
    
    (function(win) {
      'use strict';
      var listeners = [], 
      doc = win.document, 
      MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
      observer;
      function ready(selector, fn) {
        listeners.push({ selector, fn });
        if (!observer) {
          observer = new MutationObserver(check);
          observer.observe(doc.documentElement, { childList: true, subtree: true });
        }
        check();
      }
      function check() {
        for (var i = 0, len = listeners.length; i < len; i++) {
          var listener = listeners[i],
              elements = doc.querySelectorAll(listener.selector);
          for (var j = 0, jLen = elements.length; j < jLen; j++) {
            var element = elements[j];
            if (!element.ready) {
              element.ready = true;
              listener.fn.call(element, element);
            }
          }
        }
      }
      win.eleReady = ready;
    })(this);

    var pdSrchHtm = `<div class="lookingForToday">
                        <div class="stepOne">
                            <div class="topLeft"><span class="red"></span><span class="blk"></span></div>
                            <h3>What Are You Looking For Today?</h3>
                            <ul>
                                <li>
                                    <a dataAttr="performanceParts">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/4da6feeef3f5a58e3eecb7ce5bc7d582_performanceparts.png" alt="Performance parts">
                                        <span>Performance parts</span>
                                    </a>
                                </li>
                                <li>
                                    <a dataAttr="brakeSystem">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/5cb292a1b3224122055f89357a2ea599_breaksystem.png" alt="Brake System">
                                        <span>Brake System</span>
                                    </a>
                                </li>
                                <li>
                                    <a dataAttr="helmets">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/3cf2ced61db772b5c2c40ef9876209e0_helmets.png" alt="Helmets">
                                        <span>Helmets</span>
                                    </a>
                                </li>
                                <li>
                                    <a dataAttr="luggage">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/554a968be41a8f6aaad2b41607c4d3be_luggage.png" alt="Luggage">
                                        <span>Luggage</span>
                                    </a>
                                </li>
                                <li>
                                    <a dataAttr="lightsElectronics">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/f5a4303af87ab6336039e0b0c753d893_lightselectronics.png" alt="Lights & electronics">
                                        <span>Lights & electronics</span>
                                    </a>
                                </li>
                                <li>
                                    <a dataAttr="riderProtection">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/0855fcf33a4f7aa9ca24ebca8b68bd97_riderprotection.png" alt="Rider Protection">
                                        <span>Rider Protection</span>
                                    </a>
                                </li>
                            </ul>
                            <div class="bottomRight"><span class="blk"></span><span class="red"></span></div>
                        </div>
                        <div class="stepTwo" style="display: none;">
                            <div class="cp-global-header">
                                <button class="cp-back" aria-label="Back">
                                    <svg viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </button>
                                <div class="cp-title">Handle Parts</div>
                            </div>
                            <h3 class="innrTtl">What kind of <span>Helmet</span> are you looking for today?</h3>
                            <div class="stepTwoInner"></div>
                            <div class="randFcts">
                                <img src="https://useruploads.vwo.io/useruploads/1120839/images/0340ca667613bdb6000faa0ab9a83877_1.png">
                                <span>In 1914, British physician Dr. Eric Gardner designed what is considered the first motorcycle helmet after a friend died in a crash due to head trauma. He had canvas helmets lined with hard shellac made for riders in the Isle of Man TT races, urging officials to make them mandatory.</span>
                            </div>
                        </div>
                        <div class="stepThree" style="display: none;">
                            <div class="cp-global-header">
                                <button class="cp-back" aria-label="Back">
                                    <svg viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </button>
                                <div class="cp-title">Handle Parts</div>
                            </div>
                            <div class="stepThreeInner">
                                <div class="loading"></div>
                            </div>
                            <div class="randFcts">
                                <img src="https://useruploads.vwo.io/useruploads/1120839/images/0340ca667613bdb6000faa0ab9a83877_1.png">
                                <span>In 1914, British physician Dr. Eric Gardner designed what is considered the first motorcycle helmet after a friend died in a crash due to head trauma. He had canvas helmets lined with hard shellac made for riders in the Isle of Man TT races, urging officials to make them mandatory.</span>
                            </div>
                        </div>
                    </div>`;

    // UPDATED FACTS DATASET
    var facts = {
      Helmets: [
        "The first motorcycle helmet was invented in 1914 — and it saved countless lives since"
      ],
      Bikes: [
        "The very first motorcycle is credited to Gottlieb Daimler and Wilhelm Maybach in 1885...",
        "Harley-Davidson began in 1903 in a small wooden shed in Milwaukee...",
        "The first organized motorcycle race took place in 1897 in France...",
        "Ducati’s famous Desmodromic valve system was introduced in the 1970s..."
      ],
      Motocross: [
        "Motocross evolved from trial competitions in the early 1900s in the UK...",
        "The first recognized motocross race took place in 1924 in Camberley, England...",
        "Early motocross racers used standard road motorcycles, heavily modified...",
        "In the 1960s, lightweight two-stroke engines revolutionized motocross...",
        "Innovations like telescopic forks and monoshock suspensions spread from motocross..."
      ],
      Braking: [
        "Sintered pads were originally developed for fighter jets before motorcycles"
      ],
      "Lights & electronics": [
        "Aux lights became mainstream during the Paris-Dakar Rally, helping riders survive desert nights"
      ],
      "Performance parts": [
        "MotoGP bikes rev up to 18,000 RPM, powered by precision fuel mapping and exhaust tuning"
      ],
      "Rider Protection": [
        "Gear up like your life depends on it — because it does"
      ],
      "Luggage": [
        "From Himalayan expeditions to MotoGP pit crews, luggage defines how far you can really go"
      ]
    };

    $('.slideshow_tmd.mobile').after(pdSrchHtm);

    function getRandomFact(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }

    $('.lookingForToday .stepOne ul li a').click(function(){
      var getTxt = $(this).text();
      var selectedFact = "";

      $('.lookingForToday .stepOne').hide();
      $('.lookingForToday .stepTwo').show();

      if($(this).attr('dataAttr') == 'performanceParts'){
        var performancePartsHtm = $('ul.mega-menu__list a[href="/collections/performance-parts"]').parent().html();
        $('.lookingForToday .stepTwo .stepTwoInner').html(performancePartsHtm);
        selectedFact = getRandomFact(facts["Performance parts"]);
      }
      if($(this).attr('dataAttr') == 'brakeSystem'){
        var brakeSystemHtm = $('ul.mega-menu__list a#HeaderMenu-shop-by-accessories-braking').parent().html();
        $('.lookingForToday .stepTwo .stepTwoInner').html(brakeSystemHtm);
        selectedFact = getRandomFact(facts.Braking);
      }
      if($(this).attr('dataAttr') == 'helmets'){
        var helmetsHtm = $('ul.mega-menu__list a[href="/collections/helmet/helmets"]').parent().html();
        $('.lookingForToday .stepTwo .stepTwoInner').html(helmetsHtm);
        selectedFact = getRandomFact(facts.Helmets);
        $('.randFcts img').attr('src', 'https://useruploads.vwo.io/useruploads/1120839/images/0340ca667613bdb6000faa0ab9a83877_1.png');
      }
      if($(this).attr('dataAttr') == 'luggage'){
        var luggageHtm = $('ul.mega-menu__list a[href="/collections/luggage"]').parent().html();
        $('.lookingForToday .stepTwo .stepTwoInner').html(luggageHtm);
        selectedFact = getRandomFact(facts.Luggage);
      }
      if($(this).attr('dataAttr') == 'lightsElectronics'){
        var lightsElectronicsHtm = $('ul.mega-menu__list a[href="/collections/lights-and-electronics"]').parent().html();
        $('.lookingForToday .stepTwo .stepTwoInner').html(lightsElectronicsHtm);
        selectedFact = getRandomFact(facts["Lights & electronics"]);
      }
      if($(this).attr('dataAttr') == 'riderProtection'){
        var riderProtectionHtm = $('ul.mega-menu__list a[href="/collections/rider-protection"]').parent().html();
        $('.lookingForToday .stepTwo .stepTwoInner').html(riderProtectionHtm);
        selectedFact = getRandomFact(facts["Rider Protection"]);
      }

      // Fallback if no fact was selected
      if (!selectedFact) {
        var otherFacts = [...facts.Bikes, ...facts.Motocross];
        selectedFact = getRandomFact(otherFacts);
        $('.randFcts img').attr('src', 'https://useruploads.vwo.io/useruploads/1120839/images/746de32b3fb898590e919e0e9cf294f5_2.png');
      }

      $(".lookingForToday .randFcts span").text(selectedFact);

      $('.lookingForToday .stepTwo .cp-global-header .cp-title, .lookingForToday .stepTwo h3.innrTtl span').text(getTxt);

      $('.lookingForToday .stepTwoInner ul a[href*="/collections/"]').click(function(e) {
        e.stopPropagation();
        e.preventDefault();
        $('.stepThreeInner').html('<div class="loading"></div>');
        $('.lookingForToday .stepTwo').hide();
        $('.lookingForToday .stepThree').show();

        $(this).closest('li').siblings().removeClass('actv');
        $(this).closest('li').addClass('actv');

        var getThisTxt = $(this).text();
        $('.lookingForToday .stepThree .cp-global-header .cp-title').text(getThisTxt);

        var thisHref = 'https://www.sparify.co' + $(this).attr('href');
        $('.stepThree .stepThreeInner').load(thisHref + ' details[id*="Details-filter.p.m.custom.vehicle_config-template"] fieldset ul.facets-layout', function() {
          $('.stepThree li.show-more-item.hidden').removeClass('show-more-item hidden');                        
          $('.stepThree .stepThreeInner').attr('dataUrl', '?sort_by=best-selling&filter.v.price.gte=&filter.v.price.lte');
        });

        setTimeout(function(){
          if($('.stepThreeInner li.list-menu__item label').length == 0) {
            $('.stepThree .stepThreeInner').load(thisHref + ' details[id*="Details-filter.p.t.category-template"] fieldset ul.facets-layout', function() {
              $('.stepThree li.show-more-item.hidden').removeClass('show-more-item hidden');
              $('.stepThree .stepThreeInner').attr('dataUrl', '?sort_by=manual&filter.v.price.gte=&filter.v.price.lte');
            });
          }
        }, 2000);                    
      });
    });

    $('.stepTwo button.cp-back').click(function(){
      $('.lookingForToday .stepTwo').hide();
      $('.lookingForToday .stepOne').show();
    });

    $('.stepThree button.cp-back').click(function(){
      $('.lookingForToday .stepThree').hide();
      $('.lookingForToday .stepTwo').show();
      $('.stepThreeInner').html('<div class="loading"></div>');
    });

    eleReady('.lookingForToday .stepThreeInner ul.facets-layout label', function (labels) {
      var actLink = 'https://www.sparify.co' + $('.lookingForToday .stepTwoInner ul li.actv a').attr('href');
      var filLink = $('.stepThreeInner').attr('dataurl');

      var inputName = $(labels).find('input').attr('name');
      var inputValue = $(labels).find('input').attr('value');

      $(labels).attr('finalUrl', actLink + filLink + '=&' + inputName + '=' + inputValue);

      $(labels).click(function(){
        location.href = $(this).attr('finalUrl');
      });

      setTimeout(function(){
        if($('.stepThreeInner ul.facets-layout label').length < 2) {
          location.href = $('.stepThreeInner ul.facets-layout label').attr('finalurl').split('?sort_by')[0];
        }
      }, 300);
    });

  } else if (!document.querySelector('.cp_sp_hp_05_v2')) {
    window.requestAnimationFrame(window.cp_sp_hp_05_v2);
  }
};



/**/
window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function (timeOutFn) {
  return setTimeout(timeOutFn, 1000 / 60);
};

window['cp_sp_hp_05_v2'] = function () {
  if (typeof $ == 'function' && $('.slideshow_tmd.mobile').length > 0 && !document.querySelector('.cp_sp_hp_05_v2')) {
    $('body').addClass('cp_sp_hp_05_v2');
    
    (function(win) {
      'use strict';
      var listeners = [], 
      doc = win.document, 
      MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
      observer;
      function ready(selector, fn) {
        listeners.push({ selector, fn });
        if (!observer) {
          observer = new MutationObserver(check);
          observer.observe(doc.documentElement, { childList: true, subtree: true });
        }
        check();
      }
      function check() {
        for (var i = 0, len = listeners.length; i < len; i++) {
          var listener = listeners[i],
              elements = doc.querySelectorAll(listener.selector);
          for (var j = 0, jLen = elements.length; j < jLen; j++) {
            var element = elements[j];
            if (!element.ready) {
              element.ready = true;
              listener.fn.call(element, element);
            }
          }
        }
      }
      win.eleReady = ready;
    })(this);

    var pdSrchHtm = `<div class="lookingForToday">
                        <div class="stepOne">
                            <div class="topLeft"><span class="red"></span><span class="blk"></span></div>
                            <h3>What Are You Looking For Today?</h3>
                            <ul>
                                <li>
                                    <a dataAttr="performanceParts">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/4da6feeef3f5a58e3eecb7ce5bc7d582_performanceparts.png" alt="Performance parts">
                                        <span>Performance parts</span>
                                    </a>
                                </li>
                                <li>
                                    <a dataAttr="brakeSystem">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/5cb292a1b3224122055f89357a2ea599_breaksystem.png" alt="Brake System">
                                        <span>Brake System</span>
                                    </a>
                                </li>
                                <li>
                                    <a dataAttr="helmets">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/3cf2ced61db772b5c2c40ef9876209e0_helmets.png" alt="Helmets">
                                        <span>Helmets</span>
                                    </a>
                                </li>
                                <li>
                                    <a dataAttr="luggage">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/554a968be41a8f6aaad2b41607c4d3be_luggage.png" alt="Luggage">
                                        <span>Luggage</span>
                                    </a>
                                </li>
                                <li>
                                    <a dataAttr="lightsElectronics">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/f5a4303af87ab6336039e0b0c753d893_lightselectronics.png" alt="Lights & electronics">
                                        <span>Lights & electronics</span>
                                    </a>
                                </li>
                                <li>
                                    <a dataAttr="riderProtection">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/0855fcf33a4f7aa9ca24ebca8b68bd97_riderprotection.png" alt="Rider Protection">
                                        <span>Rider Protection</span>
                                    </a>
                                </li>
                            </ul>
                            <div class="bottomRight"><span class="blk"></span><span class="red"></span></div>
                        </div>
                        <div class="stepTwo" style="display: none;">
                            <div class="cp-global-header">
                                <button class="cp-back" aria-label="Back">
                                    <svg viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </button>
                                <div class="cp-title">Handle Parts</div>
                            </div>
                            <h3 class="innrTtl">What kind of <span>Helmet</span> are you looking for today?</h3>
                            <div class="stepTwoInner"></div>
                            <div class="randFcts">
                                <img src="https://useruploads.vwo.io/useruploads/1120839/images/0340ca667613bdb6000faa0ab9a83877_1.png">
                                <span>In 1914, British physician Dr. Eric Gardner designed what is considered the first motorcycle helmet after a friend died in a crash due to head trauma. He had canvas helmets lined with hard shellac made for riders in the Isle of Man TT races, urging officials to make them mandatory.</span>
                            </div>
                        </div>
                        <div class="stepThree" style="display: none;">
                            <div class="cp-global-header">
                                <button class="cp-back" aria-label="Back">
                                    <svg viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </button>
                                <div class="cp-title">Handle Parts</div>
                            </div>
                            <div class="stepThreeInner">
                                <div class="loading"></div>
                            </div>
                            <div class="randFcts">
                                <img src="https://useruploads.vwo.io/useruploads/1120839/images/0340ca667613bdb6000faa0ab9a83877_1.png">
                                <span>In 1914, British physician Dr. Eric Gardner designed what is considered the first motorcycle helmet after a friend died in a crash due to head trauma. He had canvas helmets lined with hard shellac made for riders in the Isle of Man TT races, urging officials to make them mandatory.</span>
                            </div>
                        </div>
                    </div>`;

    // UPDATED FACTS DATASET
    var facts = {
      Helmets: [
        "The first motorcycle helmet was invented in 1914 — and it saved countless lives since"
      ],
      Bikes: [
        "The very first motorcycle is credited to Gottlieb Daimler and Wilhelm Maybach in 1885...",
        "Harley-Davidson began in 1903 in a small wooden shed in Milwaukee...",
        "The first organized motorcycle race took place in 1897 in France...",
        "Ducati’s famous Desmodromic valve system was introduced in the 1970s..."
      ],
      Motocross: [
        "Motocross evolved from trial competitions in the early 1900s in the UK...",
        "The first recognized motocross race took place in 1924 in Camberley, England...",
        "Early motocross racers used standard road motorcycles, heavily modified...",
        "In the 1960s, lightweight two-stroke engines revolutionized motocross...",
        "Innovations like telescopic forks and monoshock suspensions spread from motocross..."
      ],
      Braking: [
        "Sintered pads were originally developed for fighter jets before motorcycles"
      ],
      "Lights & electronics": [
        "Aux lights became mainstream during the Paris-Dakar Rally, helping riders survive desert nights"
      ],
      "Performance parts": [
        "MotoGP bikes rev up to 18,000 RPM, powered by precision fuel mapping and exhaust tuning"
      ],
      "Rider Protection": [
        "Gear up like your life depends on it — because it does"
      ],
      "Luggage": [
        "From Himalayan expeditions to MotoGP pit crews, luggage defines how far you can really go"
      ]
    };

    $('.slideshow_tmd.mobile').after(pdSrchHtm);

    function getRandomFact(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }

    $('.lookingForToday .stepOne ul li a').click(function(){
      var getTxt = $(this).text();
      var selectedFact = "";

      $('.lookingForToday .stepOne').hide();
      $('.lookingForToday .stepTwo').show();

      if($(this).attr('dataAttr') == 'performanceParts'){
        var performancePartsHtm = $('ul.mega-menu__list a[href="/collections/performance-parts"]').parent().html();
        $('.lookingForToday .stepTwo .stepTwoInner').html(performancePartsHtm);
        selectedFact = getRandomFact(facts["Performance parts"]);
      }
      if($(this).attr('dataAttr') == 'brakeSystem'){
        var brakeSystemHtm = $('ul.mega-menu__list a#HeaderMenu-shop-by-accessories-braking').parent().html();
        $('.lookingForToday .stepTwo .stepTwoInner').html(brakeSystemHtm);
        selectedFact = getRandomFact(facts.Braking);
      }
      if($(this).attr('dataAttr') == 'helmets'){
        var helmetsHtm = $('ul.mega-menu__list a[href="/collections/helmet/helmets"]').parent().html();
        $('.lookingForToday .stepTwo .stepTwoInner').html(helmetsHtm);
        selectedFact = getRandomFact(facts.Helmets);
        $('.randFcts img').attr('src', 'https://useruploads.vwo.io/useruploads/1120839/images/0340ca667613bdb6000faa0ab9a83877_1.png');
      }
      if($(this).attr('dataAttr') == 'luggage'){
        var luggageHtm = $('ul.mega-menu__list a[href="/collections/luggage"]').parent().html();
        $('.lookingForToday .stepTwo .stepTwoInner').html(luggageHtm);
        selectedFact = getRandomFact(facts.Luggage);
      }
      if($(this).attr('dataAttr') == 'lightsElectronics'){
        var lightsElectronicsHtm = $('ul.mega-menu__list a[href="/collections/lights-and-electronics"]').parent().html();
        $('.lookingForToday .stepTwo .stepTwoInner').html(lightsElectronicsHtm);
        selectedFact = getRandomFact(facts["Lights & electronics"]);
      }
      if($(this).attr('dataAttr') == 'riderProtection'){
        var riderProtectionHtm = $('ul.mega-menu__list a[href="/collections/rider-protection"]').parent().html();
        $('.lookingForToday .stepTwo .stepTwoInner').html(riderProtectionHtm);
        selectedFact = getRandomFact(facts["Rider Protection"]);
      }

      // Fallback if no fact was selected
      if (!selectedFact) {
        var otherFacts = [...facts.Bikes, ...facts.Motocross];
        selectedFact = getRandomFact(otherFacts);
        $('.randFcts img').attr('src', 'https://useruploads.vwo.io/useruploads/1120839/images/746de32b3fb898590e919e0e9cf294f5_2.png');
      }

      $(".lookingForToday .randFcts span").text(selectedFact);

      $('.lookingForToday .stepTwo .cp-global-header .cp-title, .lookingForToday .stepTwo h3.innrTtl span').text(getTxt);

      $('.lookingForToday .stepTwoInner ul a[href*="/collections/"]').click(function(e) {
        e.stopPropagation();
        e.preventDefault();
        $('.stepThreeInner').html('<div class="loading"></div>');
        $('.lookingForToday .stepTwo').hide();
        $('.lookingForToday .stepThree').show();

        $(this).closest('li').siblings().removeClass('actv');
        $(this).closest('li').addClass('actv');

        var getThisTxt = $(this).text();
        $('.lookingForToday .stepThree .cp-global-header .cp-title').text(getThisTxt);

        var thisHref = 'https://www.sparify.co' + $(this).attr('href');
        $('.stepThree .stepThreeInner').load(thisHref + ' details[id*="Details-filter.p.m.custom.vehicle_config-template"] fieldset ul.facets-layout', function() {
          $('.stepThree li.show-more-item.hidden').removeClass('show-more-item hidden');                        
          $('.stepThree .stepThreeInner').attr('dataUrl', '?sort_by=best-selling&filter.v.price.gte=&filter.v.price.lte');
        });

        setTimeout(function(){
          if($('.stepThreeInner li.list-menu__item label').length == 0) {
            $('.stepThree .stepThreeInner').load(thisHref + ' details[id*="Details-filter.p.t.category-template"] fieldset ul.facets-layout', function() {
              $('.stepThree li.show-more-item.hidden').removeClass('show-more-item hidden');
              $('.stepThree .stepThreeInner').attr('dataUrl', '?sort_by=manual&filter.v.price.gte=&filter.v.price.lte');
            });
          }
        }, 2000);                    
      });
    });

    $('.stepTwo button.cp-back').click(function(){
      $('.lookingForToday .stepTwo').hide();
      $('.lookingForToday .stepOne').show();
    });

    $('.stepThree button.cp-back').click(function(){
      $('.lookingForToday .stepThree').hide();
      $('.lookingForToday .stepTwo').show();
      $('.stepThreeInner').html('<div class="loading"></div>');
    });

    eleReady('.lookingForToday .stepThreeInner ul.facets-layout label', function (labels) {
      var actLink = 'https://www.sparify.co' + $('.lookingForToday .stepTwoInner ul li.actv a').attr('href');
      var filLink = $('.stepThreeInner').attr('dataurl');

      var inputName = $(labels).find('input').attr('name');
      var inputValue = $(labels).find('input').attr('value');

      $(labels).attr('finalUrl', actLink + filLink + '=&' + inputName + '=' + inputValue);

      $(labels).click(function(){
        location.href = $(this).attr('finalUrl');
      });

      setTimeout(function(){
        if($('.stepThreeInner ul.facets-layout label').length < 2) {
          location.href = $('.stepThreeInner ul.facets-layout label').attr('finalurl').split('?sort_by')[0];
        }
      }, 300);
    });

  } else if (!document.querySelector('.cp_sp_hp_05_v2')) {
    window.requestAnimationFrame(window.cp_sp_hp_05_v2);
  }
};
// window.cp_sp_hp_05_v2();

window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function (timeOutFn) {
  return setTimeout(timeOutFn, 1000 / 60);
};

window['CP_SP_HP_05_V3'] = function () {
  if (document.querySelector('.slideshow_tmd.mobile') && !document.querySelector('.CP_SP_HP_05_V3')) {
    document.body.classList.add('CP_SP_HP_05_V3');
    
    const bikeModels = [
      {
          "name": "310 RR",
          "id": "60271427641",
          "full_value": "gid://shopify/Metaobject/60271427641"
      },
      {
          "name": "Adventure 250",
          "id": "18569527353",
          "full_value": "gid://shopify/Metaobject/18569527353"
      },
      {
          "name": "Adventure 390",
          "id": "13366657081",
          "full_value": "gid://shopify/Metaobject/13366657081"
      },
      {
          "name": "Apache RR 310",
          "id": "13366689849",
          "full_value": "gid://shopify/Metaobject/13366689849"
      },
      {
          "name": "Bajaj Dominar 250",
          "id": "18531156025",
          "full_value": "gid://shopify/Metaobject/18531156025"
      },
      {
          "name": "Bajaj Dominar 400",
          "id": "16938139705",
          "full_value": "gid://shopify/Metaobject/16938139705"
      },
      {
          "name": "BMW 310 GS",
          "id": "13366755385",
          "full_value": "gid://shopify/Metaobject/13366755385"
      },
      {
          "name": "BMW 310 R",
          "id": "13366722617",
          "full_value": "gid://shopify/Metaobject/13366722617"
      },
      {
          "name": "CB 350RS",
          "id": "47498395705",
          "full_value": "gid://shopify/Metaobject/47498395705"
      },
      {
          "name": "CB Hness 350",
          "id": "18553012281",
          "full_value": "gid://shopify/Metaobject/18553012281"
      },
      {
          "name": "CBR 150",
          "id": "18553077817",
          "full_value": "gid://shopify/Metaobject/18553077817"
      },
      {
          "name": "CBR 150 R",
          "id": "18553110585",
          "full_value": "gid://shopify/Metaobject/18553110585"
      },
      {
          "name": "DUCATI DIAVEL",
          "id": "16938827833",
          "full_value": "gid://shopify/Metaobject/16938827833"
      },
      {
          "name": "DUCATI MULTISTADA",
          "id": "16938795065",
          "full_value": "gid://shopify/Metaobject/16938795065"
      },
      {
          "name": "DUCATI PANIGALE",
          "id": "16938991673",
          "full_value": "gid://shopify/Metaobject/16938991673"
      },
      {
          "name": "DUCATI SCRAMBLER",
          "id": "16938958905",
          "full_value": "gid://shopify/Metaobject/16938958905"
      },
      {
          "name": "Duke 125",
          "id": "13366394937",
          "full_value": "gid://shopify/Metaobject/13366394937"
      },
      {
          "name": "Duke 200",
          "id": "13366427705",
          "full_value": "gid://shopify/Metaobject/13366427705"
      },
      {
          "name": "Duke 250",
          "id": "13366493241",
          "full_value": "gid://shopify/Metaobject/13366493241"
      },
      {
          "name": "DUKE 250 gen 3",
          "id": "80815980601",
          "full_value": "gid://shopify/Metaobject/80815980601"
      },
      {
          "name": "Duke 390",
          "id": "13366460473",
          "full_value": "gid://shopify/Metaobject/13366460473"
      },
      {
          "name": "DUKE 390 (gen 3)",
          "id": "77211107385",
          "full_value": "gid://shopify/Metaobject/77211107385"
      },
      {
          "name": "GUERRILLA 450",
          "id": "67147366457",
          "full_value": "gid://shopify/Metaobject/67147366457"
      },
      {
          "name": "HAYABUSA",
          "id": "18552684601",
          "full_value": "gid://shopify/Metaobject/18552684601"
      },
      {
          "name": "Himalayan 450",
          "id": "61257285689",
          "full_value": "gid://shopify/Metaobject/61257285689"
      },
      {
          "name": "HONDA HIGHNESS 350",
          "id": "16939384889",
          "full_value": "gid://shopify/Metaobject/16939384889"
      },
      {
          "name": "KAWASAKI NINJA",
          "id": "16939155513",
          "full_value": "gid://shopify/Metaobject/16939155513"
      },
      {
          "name": "KAWASAKI VERSYS 650",
          "id": "16939188281",
          "full_value": "gid://shopify/Metaobject/16939188281"
      },
      {
          "name": "KAWASAKI VULCAN S",
          "id": "16939221049",
          "full_value": "gid://shopify/Metaobject/16939221049"
      },
      {
          "name": "KAWASAKI Z650",
          "id": "16939253817",
          "full_value": "gid://shopify/Metaobject/16939253817"
      },
      {
          "name": "KAWASAKI Z800",
          "id": "16938762297",
          "full_value": "gid://shopify/Metaobject/16938762297"
      },
      {
          "name": "KAWASAKI Z900",
          "id": "16939352121",
          "full_value": "gid://shopify/Metaobject/16939352121"
      },
      {
          "name": "MT15",
          "id": "34298462265",
          "full_value": "gid://shopify/Metaobject/34298462265"
      },
      {
          "name": "NINJA 650",
          "id": "16938926137",
          "full_value": "gid://shopify/Metaobject/16938926137"
      },
      {
          "name": "NS 160",
          "id": "18559336505",
          "full_value": "gid://shopify/Metaobject/18559336505"
      },
      {
          "name": "NS 200",
          "id": "16938205241",
          "full_value": "gid://shopify/Metaobject/16938205241"
      },
      {
          "name": "Pulsar",
          "id": "13365674041",
          "full_value": "gid://shopify/Metaobject/13365674041"
      },
      {
          "name": "pulsar rs 200",
          "id": "18530598969",
          "full_value": "gid://shopify/Metaobject/18530598969"
      },
      {
          "name": "R15 v3",
          "id": "18551078969",
          "full_value": "gid://shopify/Metaobject/18551078969"
      },
      {
          "name": "R15 v4",
          "id": "18559959097",
          "full_value": "gid://shopify/Metaobject/18559959097"
      },
      {
          "name": "RC 125",
          "id": "13366526009",
          "full_value": "gid://shopify/Metaobject/13366526009"
      },
      {
          "name": "RC 200",
          "id": "13366558777",
          "full_value": "gid://shopify/Metaobject/13366558777"
      },
      {
          "name": "RC 390",
          "id": "13366591545",
          "full_value": "gid://shopify/Metaobject/13366591545"
      },
      {
          "name": "RE BEAR 650",
          "id": "82964480057",
          "full_value": "gid://shopify/Metaobject/82964480057"
      },
      {
          "name": "RE classic 350",
          "id": "18530402361",
          "full_value": "gid://shopify/Metaobject/18530402361"
      },
      {
          "name": "RE Classic Reborn 350",
          "id": "83412680761",
          "full_value": "gid://shopify/Metaobject/83412680761"
      },
      {
          "name": "RE Continental GT 535",
          "id": "34246787129",
          "full_value": "gid://shopify/Metaobject/34246787129"
      },
      {
          "name": "RE GT 650",
          "id": "16938696761",
          "full_value": "gid://shopify/Metaobject/16938696761"
      },
      {
          "name": "RE HIMALAYAN",
          "id": "16939286585",
          "full_value": "gid://shopify/Metaobject/16939286585"
      },
      {
          "name": "RE Hunter",
          "id": "18559205433",
          "full_value": "gid://shopify/Metaobject/18559205433"
      },
      {
          "name": "RE INT 650",
          "id": "16938663993",
          "full_value": "gid://shopify/Metaobject/16938663993"
      },
      {
          "name": "RE meteor 350",
          "id": "18559369273",
          "full_value": "gid://shopify/Metaobject/18559369273"
      },
      {
          "name": "RE Reborn 350",
          "id": "71805370425",
          "full_value": "gid://shopify/Metaobject/71805370425"
      },
      {
          "name": "RE SCRAM 411",
          "id": "16939319353",
          "full_value": "gid://shopify/Metaobject/16939319353"
      },
      {
          "name": "RE Shotgun 650",
          "id": "80820994105",
          "full_value": "gid://shopify/Metaobject/80820994105"
      },
      {
          "name": "RE Super Meteor 650",
          "id": "18559402041",
          "full_value": "gid://shopify/Metaobject/18559402041"
      },
      {
          "name": "SR 125",
          "id": "13365772345",
          "full_value": "gid://shopify/Metaobject/13365772345"
      },
      {
          "name": "Sr 150",
          "id": "13365739577",
          "full_value": "gid://shopify/Metaobject/13365739577"
      },
      {
          "name": "SR 160",
          "id": "13365837881",
          "full_value": "gid://shopify/Metaobject/13365837881"
      },
      {
          "name": "Storm 125",
          "id": "13366296633",
          "full_value": "gid://shopify/Metaobject/13366296633"
      },
      {
          "name": "Storm 160",
          "id": "13366329401",
          "full_value": "gid://shopify/Metaobject/13366329401"
      },
      {
          "name": "TRIUMPH DYTONA 675",
          "id": "16939024441",
          "full_value": "gid://shopify/Metaobject/16939024441"
      },
      {
          "name": "TRIUMPH EXPLORER 1200",
          "id": "16939089977",
          "full_value": "gid://shopify/Metaobject/16939089977"
      },
      {
          "name": "Triumph scrambler 400 X",
          "id": "71526285369",
          "full_value": "gid://shopify/Metaobject/71526285369"
      },
      {
          "name": "Triumph Speed 400",
          "id": "18568642617",
          "full_value": "gid://shopify/Metaobject/18568642617"
      },
      {
          "name": "TRIUMPH STREET TRIPLE",
          "id": "16938631225",
          "full_value": "gid://shopify/Metaobject/16938631225"
      },
      {
          "name": "TRIUMPH TIGER",
          "id": "16939057209",
          "full_value": "gid://shopify/Metaobject/16939057209"
      },
      {
          "name": "TVS NTORQ",
          "id": "41187967033",
          "full_value": "gid://shopify/Metaobject/41187967033"
      },
      {
          "name": "X PLUSE 200",
          "id": "33560395833",
          "full_value": "gid://shopify/Metaobject/33560395833"
      },
      {
          "name": "XPULSE 200",
          "id": "16938729529",
          "full_value": "gid://shopify/Metaobject/16938729529"
      },
      {
          "name": "YAMAHA AEROK 155",
          "id": "16939417657",
          "full_value": "gid://shopify/Metaobject/16939417657"
      },
      {
          "name": "Yamaha Aerox 155",
          "id": "18566742073",
          "full_value": "gid://shopify/Metaobject/18566742073"
      },
      {
          "name": "Yamaha r3",
          "id": "18563006521",
          "full_value": "gid://shopify/Metaobject/18563006521"
      },
      {
          "name": "YAMAHA SR 400",
          "id": "16938893369",
          "full_value": "gid://shopify/Metaobject/16938893369"
      },
      {
          "name": "Yezdi Adventure",
          "id": "18563170361",
          "full_value": "gid://shopify/Metaobject/18563170361"
      },
      {
          "name": "YEZDI SCRAMBLER",
          "id": "18561499193",
          "full_value": "gid://shopify/Metaobject/18561499193"
      },
      {
          "name": "YZF R3",
          "id": "16938860601",
          "full_value": "gid://shopify/Metaobject/16938860601"
      }
    ];
    
    const productNavigation = {
      "Helmet": {
        subcategories: {
          "Motocross": {
            brands: ["SMK", "Acerbis", "Royal Enfield"],
            collectionUrl: "/collections/motocross-helmets",
            haveCustomUrls: true,
            customUrls: ["https://www.sparify.co/search?q=allterra&options%5Bprefix%5D=last", "https://www.sparify.co/search?q=acerbis+helmet&options%5Bprefix%5D=last", "https://www.sparify.co/search?q=Royal+Enfield+helmet&options%5Bprefix%5D=last"]
          },
          "Flip up": {
            hasFilter: true,
            collectionUrl: "/collections/flip-up-helmet?filter.p.t.category=vp-1-6-1-7"
          },
          "Full face": {
            brands: ["SMK", "Royal Enfield", "Studds"],
            collectionUrl: "https://www.sparify.co/collections/full-face-helmet",
            haveCustomUrls: true,
            customUrls: ["https://www.sparify.co/collections/smk-full-face-helmet?_pos=1&_psq=full-face+SMK+helmet&_ss=e&_v=1.0", "https://www.sparify.co/search?q=Royal+Enfield+full-face+helmet&filter.p.t.category=vp-1-6-1-7", "https://www.sparify.co/search?q=studds+helmet&_pos=1&_psq=studds&_ss=e&_v=1.0"]
          },
          "Half face": {
            brands: ["SMK", "Studds"],
            collectionUrl: "/collections/half-face-helmet",
            haveCustomUrls: true,
            customUrls: ["https://www.sparify.co/search?q=smk&options%5Bprefix%5D=last&filter.p.t.category=vp-1-6-1-7-2", "https://www.sparify.co/search?q=studds+ray&options%5Bprefix%5D=last"],
          },
          "Retro": {
            brands: ["SMK"],
            collectionUrl: "/collections/retro-helmets",
            haveCustomUrls: true,
            customUrls: ["https://www.sparify.co/search?q=smk+retro&options%5Bprefix%5D=last"]
          }
        }
      },
      "Performance parts": {
        subcategories: {
          "Air filter": {
            bikeModels: true,
            collectionUrl: "/collections/bikes-air-filter-and-oil-filter"
          },
          "Exhaust": {
            bikeModels: true,
            collectionUrl: "/collections/performance-exhaust"
          },
          "Iridium spark plug": {
            bikeModels: true,
            collectionUrl: "/collections/iridium-spark-plug"
          },
          "FuelX": {
            bikeModels: true,
            collectionUrl: "/collections/fuelx"
          }
        }
      },
      "Braking": {
        subcategories: {
          "Ceramic": {
            bikeModels: true,
            collectionUrl: "/collections/ceramic-brake-pads"
          },
          "Sintered": {
            bikeModels: true,
            collectionUrl: "/collections/sintered-brake-pads"
          }
        }
      },
      "Luggage": {
        subcategories: {
          "Hard Luggage": {
            brands: ["LGP", "JB RACING"],
            collectionUrl: "/collections/hard-luggage",
            haveCustomUrls: true,
            customUrls: ["https://www.sparify.co/collections/hard-luggage","https://www.sparify.co/collections/top-box-and-panniers-jb-racing"]
          },
          "Soft Luggage": {
            brands: ["MOTOWOLF", "CARBONADO", "RAIDA"],
            collectionUrl: "/collections/soft-luggage",
            haveCustomUrls: true,
            customUrls: ["https://www.sparify.co/search?q=motowolf&options%5Bprefix%5D=last", 
                          "https://www.sparify.co/search?q=carbonado&options%5Bprefix%5D=last", 
                          "https://www.sparify.co/collections/soft-luggage-raida" ]
          }
        }
      },
      "Lights & electronics": {
        subcategories: {
          "LED aux lights": {
            brands: ["HJG", "MADDOG", "LGP"],
            collectionUrl: "/collections/led-auxiliary-lights",
            haveCustomUrls: true,
            customUrls: ["https://www.sparify.co/search?q=HJG&options%5Bprefix%5D=last", 
                          "https://www.sparify.co/search?q=maddog&options%5Bprefix%5D=last", 
                          "https://www.sparify.co/collections/lgp-auxiliary-lights"]
          },
          "Hazard flasher": {
            bikeModels: true,
            collectionUrl: "/collections/hazard-flasher"
          },
          "FuelX": {
            bikeModels: true,
            collectionUrl: "/collections/fuel-x"
          },
          "Intercom": {
            brands: ["Bluarmor", "Sena", "Motowolf", "LGP", "Ejeas"],
            collectionUrl: "/collections/intercom-bluetooth",
            haveCustomUrls: true,
            customUrls: ["https://www.sparify.co/search?q=Bluarmor&options%5Bprefix%5D=last",
              "https://www.sparify.co/search?q=sena&options%5Bprefix%5D=last", 
              "https://www.sparify.co/products/motowolf-bh1-motorcycle-helmet-headset-bluetooth-headset-for-full-face-helmet-hard-microphone-advanced-motorcycle-communication?_pos=1&_psq=bh1&_ss=e&_v=1.0", 
              "https://www.sparify.co/search?q=lgp+lights", 
              "https://www.sparify.co/search?q=ejeas"]
          },
          "GPS tracker": {
            hasFilter: true,
            collectionUrl: "/collections/gps-tracker"
          },
          "Dash cam": {
            hasFilter: true,
            collectionUrl: "/products/c5-5-pro-motorcycle-carplay-with-front-rear-dash-cam-with-1-year-warranty"
          },
          "Tyre inflator": {
            hasFilter: true,
            collectionUrl: "/products/lgp-t15a-tire-inflator-portable-air-compressor-150-psi-portable-air-pump-with-accurate-led-tire-pressure-display-fast-inflation-for-vehicles-motorcycle-bikes-tires-car-balls-swimming-ring"
          }
        }
      },
      "Rider Protection": {
        subcategories: {
          "Gloves": {
            //sizes: ["S", "M", "L", "XL", "2XL"],
            collectionUrl: "/collections/gloves"
          },
          "Goggles": {
            //hasFilter: true,
            collectionUrl: "/collections/goggles"
          },
          "Riding jacket": {
            //sizes: ["S", "M", "L", "XL", "2XL"],
            collectionUrl: "/collections/riding-jacket"
          },
          "Cap": {
            //hasFilter: true,
            collectionUrl: "/collections/cap"
          },
          "Face mask": {
            //hasFilter: true,
            collectionUrl: "/collections/face-mask-balaclava"
          },
          "Boots": {
            //sizes: ["7", "8", "9", "10", "11", "12"],
            collectionUrl: "/collections/riding-boots"
          }
        }
      }
    };

    const categoryFacts = {
      "Helmet": "The first motorcycle helmet was invented in 1914 — and it saved countless lives since",
      "Performance parts": "MotoGP bikes rev up to 18,000 RPM, powered by precision fuel mapping and exhaust tuning",
      "Braking": "Sintered pads were originally developed for fighter jets before motorcycles",
      "Luggage": "From Himalayan expeditions to MotoGP pit crews, luggage defines how far you can really go",
      "Lights & electronics": "Aux lights became mainstream during the Paris-Dakar Rally, helping riders survive desert nights",
      "Rider Protection": "Gear up like your life depends on it — because it does"
    };

    const mainHtml = `<div class="lookingForToday">
                        <div class="stepOne">
                            <div class="topLeft"><span class="red"></span><span class="blk"></span></div>
                            <h3>What Are You Looking For Today?</h3>
                            <ul>
                                <li>
                                    <a data-category="Performance parts">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/4da6feeef3f5a58e3eecb7ce5bc7d582_performanceparts.png" alt="Performance parts">
                                        <span>Performance parts</span>
                                    </a>
                                </li>
                                <li>
                                    <a data-category="Braking">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/5cb292a1b3224122055f89357a2ea599_breaksystem.png" alt="Brake System">
                                        <span>Brake System</span>
                                    </a>
                                </li>
                                <li>
                                    <a data-category="Helmet">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/3cf2ced61db772b5c2c40ef9876209e0_helmets.png" alt="Helmets">
                                        <span>Helmets</span>
                                    </a>
                                </li>
                                <li>
                                    <a data-category="Luggage">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/554a968be41a8f6aaad2b41607c4d3be_luggage.png" alt="Luggage">
                                        <span>Luggage</span>
                                    </a>
                                </li>
                                <li>
                                    <a data-category="Lights & electronics">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/f5a4303af87ab6336039e0b0c753d893_lightselectronics.png" alt="Lights & electronics">
                                        <span>Lights & electronics</span>
                                    </a>
                                </li>
                                <li>
                                    <a data-category="Rider Protection">
                                        <img src="https://useruploads.vwo.io/useruploads/1120839/images/0855fcf33a4f7aa9ca24ebca8b68bd97_riderprotection.png" alt="Rider Protection">
                                        <span>Rider Protection</span>
                                    </a>
                                </li>
                            </ul>
                            <div class="bottomRight"><span class="blk"></span><span class="red"></span></div>
                        </div>
                        <div class="stepTwo" style="display: none;">
                            <div class="cp-global-header">
                                <button class="cp-back" aria-label="Back">
                                    <svg viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </button>
                                <div class="cp-title">Category</div>
                            </div>
                            <div class="randFcts">
                                <img src="https://useruploads.vwo.io/useruploads/1120839/images/0340ca667613bdb6000faa0ab9a83877_1.png" alt="Fact image">
                                <span>Interesting fact will appear here</span>
                            </div>
                            <h3 class="innrTtl">What kind of <span>Product</span> are you looking for today?</h3>
                            <div class="stepTwoInner"></div>
                        </div>
                        <div class="stepThree" style="display: none;">
                            <div class="cp-global-header">
                                <button class="cp-back" aria-label="Back">
                                    <svg viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                </button>
                                <div class="cp-title">Subcategory</div>
                            </div>
                            <div class="stepThreeInner">
                                <div class="loading"></div>
                            </div>
                        </div>
                    </div>`;

    const slideshow = document.querySelector('.slideshow_tmd.mobile');
    slideshow.insertAdjacentHTML('afterend', mainHtml);

    const widget = document.querySelector('.lookingForToday');
    const stepOne = widget.querySelector('.stepOne');
    const stepTwo = widget.querySelector('.stepTwo');
    const stepThree = widget.querySelector('.stepThree');

    let currentCategory = '';
    let currentSubcategory = '';
    let collectionUrl = '';
    let selectedCategoryLink = null;
    let selectedSubcategoryLink = null;
    let currentSubcategoryData = null;

    const showStep = (step) => {
      stepOne.style.display = 'none';
      stepTwo.style.display = 'none';
      stepThree.style.display = 'none';
      
      if (step === 'one') stepOne.style.display = 'block';
      if (step === 'two') stepTwo.style.display = 'block';
      if (step === 'three') stepThree.style.display = 'block';
    };

    const renderSubcategories = (subcategories) => {
      let html = '<ul>';
      for (const subcat in subcategories) {
        html += `<li><a data-subcategory="${subcat}">${subcat}</a></li>`;
      }
      html += '</ul>';
      widget.querySelector('.stepTwoInner').innerHTML = html;
      
      if (currentSubcategory) {
        const subcatLinks = widget.querySelectorAll('.stepTwoInner a');
        subcatLinks.forEach(link => {
          if (link.getAttribute('data-subcategory') === currentSubcategory) {
            link.classList.add('actv');
            selectedSubcategoryLink = link;
          }
        });
      }
    };

    const renderOptions = (optionData, type) => {
      let html = '<ul class="facets-layout' + (type === 'bikeModels' ? ' bike-models-list' : '') + '">';
      
      if (type === 'brands') {
        optionData.forEach((brand, index) => {
          html += `<li><label data-brand="${brand}" data-index="${index}">${brand}</label></li>`;
        });
      } else if (type === 'sizes') {
        optionData.forEach((size, index) => {
          html += `<li><label data-size="${size}" data-index="${index}">${size}</label></li>`;
        });
      } else if (type === 'options') {
        optionData.forEach((option, index) => {
          html += `<li><label data-option="${option}" data-index="${index}">${option}</label></li>`;
        });
      } else if (type === 'bikeModels') {
        bikeModels.forEach(model => {
          html += `<li><label data-bike-model="${model.full_value}">${model.name}</label></li>`;
        });
      }
      
      html += '</ul>';
      widget.querySelector('.stepThreeInner').innerHTML = html;
    };

    const navigateToCollection = (url, filters) => {
      const origin = new URL(window.location.href)?.origin;
      let finalUrl = origin + url;
      if (filters) {
        finalUrl += '?' + filters;
      }
      location.href = finalUrl;
    };

    const navigateToCustomUrl = (url) => {
      location.href = url;
    };

    stepOne.querySelectorAll('ul li a').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const selectedCategory = link.getAttribute('data-category');
        const categoryData = productNavigation[selectedCategory];
        
        if (!categoryData) return;
        
        if (selectedCategoryLink) {
          selectedCategoryLink.parentElement.classList.remove('actv');
        }
        link.parentElement.classList.add('actv');
        selectedCategoryLink = link;
        
        currentCategory = selectedCategory;
        
        stepTwo.querySelector('.cp-title').textContent = selectedCategory;
        stepTwo.querySelector('.innrTtl span').textContent = selectedCategory;
        
        const fact = categoryFacts[selectedCategory] || categoryFacts["Helmet"];
        stepTwo.querySelector('.randFcts span').textContent = fact;
        
        renderSubcategories(categoryData.subcategories);
        
        showStep('two');
      });
    });

    widget.addEventListener('click', (e) => {
      if (e.target.closest('.stepTwoInner a')) {
        e.preventDefault();
        const link = e.target.closest('.stepTwoInner a');
        const selectedSubcategory = link.getAttribute('data-subcategory');
        const subcategoryData = productNavigation[currentCategory].subcategories[selectedSubcategory];
        
        stepThree.querySelector('.cp-title').textContent = selectedSubcategory;
        
        widget.querySelectorAll('.stepTwoInner a').forEach(a => a.classList.remove('actv'));
        link.classList.add('actv');
        selectedSubcategoryLink = link;
        
        currentSubcategory = selectedSubcategory;
        currentSubcategoryData = subcategoryData;
        collectionUrl = subcategoryData.collectionUrl;
        
        if (subcategoryData.bikeModels) {
          renderOptions(null, 'bikeModels');
          showStep('three');
        } else if (subcategoryData.brands) {
          renderOptions(subcategoryData.brands, 'brands');
          showStep('three');
        } else if (subcategoryData.sizes) {
          renderOptions(subcategoryData.sizes, 'sizes');
          showStep('three');
        } else if (subcategoryData.options) {
          renderOptions(subcategoryData.options, 'options');
          showStep('three');
        } else if (subcategoryData.hasFilter) {
          navigateToCollection(subcategoryData.collectionUrl);
        } else {
          navigateToCollection(subcategoryData.collectionUrl);
        }
      }
    });

    widget.addEventListener('click', (e) => {
      if (e.target.closest('.stepThreeInner label')) {
        e.preventDefault();
        const label = e.target.closest('.stepThreeInner label');
        const selectedOption = label.textContent;
        const optionIndex = label.getAttribute('data-index');
        
        // Check if current subcategory has custom URLs
        if (currentSubcategoryData && currentSubcategoryData.haveCustomUrls && currentSubcategoryData.customUrls && optionIndex !== null) {
          const customUrl = currentSubcategoryData.customUrls[parseInt(optionIndex)];
          if (customUrl) {
            navigateToCustomUrl(customUrl);
            return;
          }
        }
        
        // Default behavior with filters
        let filterParam = '';
        if (label.hasAttribute('data-bike-model')) {
          filterParam = 'filter.p.m.custom.vehicle_config=' + encodeURIComponent(label.getAttribute('data-bike-model'));
        } else if (label.hasAttribute('data-brand')) {
          filterParam = 'filter.p.brand=' + encodeURIComponent(selectedOption);
        } else if (label.hasAttribute('data-size')) {
          filterParam = 'filter.p.size=' + encodeURIComponent(selectedOption);
        } else if (label.hasAttribute('data-option') && selectedOption === "Bike specific") {
          filterParam = 'filter.p.bike=*';
        }
        
        navigateToCollection(collectionUrl, filterParam);
      }
    });

    stepTwo.querySelector('.cp-back').addEventListener('click', () => {
      showStep('one');
    });

    stepThree.querySelector('.cp-back').addEventListener('click', () => {
      showStep('two');
    });

    const style = document.createElement('style');
    style.textContent = `
      .stepThree .bike-models-list {
        max-height: 400px;
        overflow-y: auto;
      }
    `;
    document.head.appendChild(style);

  } else if (!document.querySelector('.CP_SP_HP_05_V3')) {
    window.requestAnimationFrame(window.CP_SP_HP_05_V3);
  }
};

window.CP_SP_HP_05_V3();